import { render } from "./SingleProduct.vue?vue&type=template&id=fb1b9146&scoped=true"
import script from "./SingleProduct.vue?vue&type=script&lang=js"
export * from "./SingleProduct.vue?vue&type=script&lang=js"

import "./SingleProduct.vue?vue&type=style&index=0&id=fb1b9146&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb1b9146"]])

export default __exports__